import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL, BASE_URL1 } from './Constants.js';
import { Spinner, Alert } from 'react-bootstrap';

const Transfer_Stock_Update = () => {
  const [destinationStock, setDestinationStock] = useState(null);
  const [stock, setStock] = useState({
    area: '',
    to_area: '',
    dress_type: '',
    dress_size: '',
    dress_color: '',
    quantity: '',
    status: 'Pending',
    remarks: '',
    gnr_number: '',
    gnr_date: '',
    gnr_image: '',
    gnr_image_file: null,
  });

  const [areas, setAreas] = useState([]);
  const [dressTypes, setDressTypes] = useState([]);
  const [dressSizes, setDressSizes] = useState([]);
  const [dressColors, setDressColors] = useState([]);
  const [formError, setFormError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  // Fetch user profile
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    fetch(`${BASE_URL}profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then(res => res.json())
      .then(data => setUser(data.profile.is_uniform_access_given))
      .catch(err => console.error('Profile fetch error:', err));
  }, []);

  const checkDestinationStock = async (
    toAreaId,
    dressType,
    dressSize,
    dressColor
  ) => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `${BASE_URL}check_destination_stock?area_id=${toAreaId}&dress_type=${dressType}&dress_size=${dressSize}&dress_color=${dressColor}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (result.status) {
        setDestinationStock(result.stock);
      } else {
        setDestinationStock(null);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch dropdown options
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const fetchOptions = async () => {
      try {
        const [areaRes, typeRes, sizeRes, colorRes] = await Promise.all([
          fetch(`${BASE_URL}areas`, { headers: { Authorization: `Bearer ${token}` } }),
          fetch(`${BASE_URL}dress_types`, { headers: { Authorization: `Bearer ${token}` } }),
          fetch(`${BASE_URL}dress_sizes`, { headers: { Authorization: `Bearer ${token}` } }),
          fetch(`${BASE_URL}dress_colors`, { headers: { Authorization: `Bearer ${token}` } }),
        ]);

        const [areaData, typeData, sizeData, colorData] = await Promise.all([
          areaRes.json(),
          typeRes.json(),
          sizeRes.json(),
          colorRes.json(),
        ]);

        setAreas(areaData.areas || []);
        setDressTypes(typeData.dressTypes || []);
        setDressSizes(sizeData.dressSizes || []);
        setDressColors(colorData.dressColors || []);
      } catch (err) {
        console.error('Dropdown fetch error:', err);
      }
    };

    fetchOptions();
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    fetch(`${BASE_URL}check_stock_transfer/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          const stockData = data.stock;

          setStock({
            area: stockData.from_area_id,
            to_area: stockData.to_area_id,
            stock_id: stockData.stock_id,
            from_area: stockData.from_area,
            to_area_name: stockData.to_area,

            dress_type: stockData.dress_type_id,
            dress_size: stockData.dress_size_id,
            dress_color: stockData.dress_color_id,
            status: stockData.transfer_status || "Pending",
            remarks: stockData.remarks || "",
            quantity: stockData.quantity,
            gender: stockData.gender,
            gnr_number: stockData.gnr_number,
            gnr_date: stockData.gnr_date,
            gnr_image: stockData.gnr_image,
            gnr_image_file: null,
          });

          checkDestinationStock(
            stockData.to_area_id,
            stockData.dress_type_id,
            stockData.dress_size_id,
            stockData.dress_color_id
          );
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setStock((prev) => ({
      ...prev,
      [name]: value,
    }));

    // if (name === "to_area") {
    //   checkDestinationStock(value);
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stock.area || !stock.dress_type || !stock.dress_size || !stock.dress_color || !stock.quantity) {
      setFormError('All fields are required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('area_id', stock.area);
      formData.append('id', id);
      formData.append('to_area', stock.to_area);
      formData.append('dress_type', stock.dress_type);
      formData.append('dress_size', stock.dress_size);
      formData.append('dress_color', stock.dress_color);
      formData.append('quantity', stock.quantity);
      formData.append('gnr_number', stock.gnr_number);
      formData.append('gnr_date', stock.gnr_date);
      formData.append("status", stock.status);
      formData.append("remarks", stock.remarks);
      if (stock.gnr_image_file) {
        formData.append('gnr_image', stock.gnr_image_file);
      }

      const response = await fetch(`${BASE_URL}transfer_stock/${stock.stock_id}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const result = await response.json();

      if (result.status) {
        navigate('/manage_transfers');
      } else {
        setFormError(result.message || 'Failed to update stock.');
      }
    } catch (error) {
      setFormError('Error updating stock.');
    }
  };

  const handleBackClick = () => navigate('/manage_transfers');

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  if (loading) {
    return <div className="text-center mt-5"><Spinner animation="border" variant="primary" /></div>;
  }

  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container" style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',
      }}>
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="col-lg-6 offset-lg-3">
                <div className="card add-user-card">
                  <div className="card-header">
                    <h2>Transfer Stock</h2>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      {formError && <div className="alert alert-danger">{formError}</div>}

                      <div className="form-group">
                        <label>From Area</label>
                        <input
                          type="text"
                          className="form-control"
                          value={stock.from_area}
                          readOnly
                        />
                      </div>

                      <div className="form-group">
                        <label>Transfer To Area</label>
                        <input
                          type="text"
                          className="form-control"
                          value={stock.to_area_name}
                          readOnly
                        />
                      </div>

                      {destinationStock && (
                        <div className="alert alert-info mt-2">
                          <strong>Destination Stock Available</strong>
                          <br />
                          Quantity : {destinationStock.quantity}
                        </div>
                      )}
                      {stock.to_area && !destinationStock && (
                        <div className="alert alert-warning mt-2">
                          No stock found in selected area. A new stock record will be created.
                        </div>
                      )}

                      <div className="form-group">
                        <label>Dress Type</label>
                        <select className="form-control" name="dress_type" value={stock.dress_type} onChange={handleInputChange} disabled>
                          <option value="">Select Type</option>
                          {dressTypes.map(t => <option key={t.id} value={t.id}>{t.dress_type}</option>)}

                        </select>
                      </div>

                      <div className="form-group">
                        <label>Gender</label>
                        <input
                          type="text"
                          className="form-control"
                          value={stock.gender}
                          readOnly
                        />
                      </div>

                      <div className="form-group">
                        <label>Dress Size</label>
                        <select className="form-control" name="dress_size" value={stock.dress_size} onChange={handleInputChange} disabled>
                          <option value="">Select Size</option>
                          {dressSizes.map(s => <option key={s.id} value={s.id}>{s.dress_size}</option>)}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Dress Color</label>
                        <select className="form-control" name="dress_color" value={stock.dress_color} onChange={handleInputChange} disabled>
                          <option value="">Select Color</option>
                          {dressColors.map(c => <option key={c.id} value={c.id}>{c.dress_color}</option>)}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Quantity</label>
                        <input type="number" className="form-control" name="quantity" value={stock.quantity} onChange={handleInputChange} disabled />
                      </div>

                      <div className="form-group">
                        <label>Status</label>
                        <select
                          className="form-control"
                          name="status"
                          value={stock.status}
                          onChange={handleInputChange}
                        >
                          <option value="Pending">Pending</option>
                          <option value="Approved">Approved</option>
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Remarks</label>
                        <textarea
                          className="form-control"
                          name="remarks"
                          value={stock.remarks}
                          onChange={handleInputChange}
                          rows="3"
                          placeholder="Enter Remarks"
                          required
                        />
                      </div>

                      <div className="d-flex justify-content-between">
                        <button type="submit" className="btn btn-primary" >Update</button>
                        <button type="button" className="btn btn-secondary" onClick={handleBackClick}>Cancel</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Transfer_Stock_Update;
